module.exports = __webpack_public_path__ + "img/header-weddingRingsRosegold.eec7de8.webp";